import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Row, Col, Space } from 'antd';
import Button from 'components/Button';
import InputSelect from 'components/InputSelect';
import InputText from 'components/InputText';
import { fetchGetAtendentesLista } from 'store/fetchActions/fetchAtendente';
import { fetchGetTodasSituacoes, fetchGetTodosCargos } from 'store/fetchActions/fetchInputForm';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { TODOS_CONDICOES_STATUS } from 'utils/consts';
import { changeInputFilter } from 'utils/formUtils';
import { formatterFiltroAtendenteFrontToBack } from 'utils/formatter/filtro';
import * as Style from 'components/Style';
import * as S from './styles';

export default function Filtro({ salvarFiltro }) {
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const inputSelectOptionsCargo = useSelector(state => state.inputs.inputSelectOptionsCargo);
  const inputSelectOptionsSituacao = useSelector(state => state.inputs.inputSelectOptionsSituacao);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      atendente: '',
      cargoId: '',
      situacaoId: '',
      condicaoId: '',
    },
  });

  const handleChange = e => {
    changeInputFilter(e, setValue);
  };

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodosCargos(inputSelectOptionsCargo));
    dispatch(fetchGetTodasSituacoes(inputSelectOptionsSituacao));
    // eslint-disable-next-line
  }, [dispatch]);

  const onSubmit = data => {
    const dadosFormatados = formatterFiltroAtendenteFrontToBack(data);
    salvarFiltro(dadosFormatados);
    dispatch(fetchGetAtendentesLista(1, 10, dadosFormatados));
  };

  const limparFiltro = () => {
    setValue('atendente', '');
    setValue('cargoId', '');
    setValue('situacaoId', '');
    setValue('condicaoId', '');
    salvarFiltro({});
    dispatch(fetchGetAtendentesLista(1, 10));
  };

  return (
    <form>
      <Style.GlobalCard>
        <Row>
          <Col xs={24} sm={16} md={8} lg={6} xl={6}>
            <InputText
              label="Atendente"
              name="atendente"
              placeholder={'Atendente'}
              control={control}
              onChange={handleChange}
              maxLength={150}
              errors={errors}
            />
          </Col>
          <Col xs={24} sm={16} md={8} lg={5} xl={3}>
            <InputSelect
              label="Cargo"
              name="cargoId"
              placeholder={'Cargo'}
              control={control}
              options={montarDadosInputSelect(inputSelectOptionsCargo, 'id', 'descricao')}
            />
          </Col>
          <Col xs={24} sm={16} md={8} lg={5} xl={3}>
            <InputSelect
              label="Situação"
              name="situacaoId"
              placeholder={'Situação'}
              control={control}
              options={montarDadosInputSelect(inputSelectOptionsSituacao, 'id', 'descricao')}
            />
          </Col>
          <Col xs={24} sm={16} md={8} lg={5} xl={3}>
            <InputSelect
              label="Condição"
              name="condicaoId"
              placeholder={'Condição'}
              control={control}
              options={montarDadosInputSelect(TODOS_CONDICOES_STATUS, 'id', 'label')}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={5}>
            <S.ContainButton>
              <Space>
                <Button text={'Pesquisar'} clickAction={handleSubmit(onSubmit)} />
                <Button text={'Limpar Filtro'} clickAction={() => limparFiltro()} />
              </Space>
            </S.ContainButton>
          </Col>
        </Row>
      </Style.GlobalCard>
    </form>
  );
}
